import { render, staticRenderFns } from "./CompleteCarrier.vue?vue&type=template&id=54acba5e&scoped=true&"
import script from "./CompleteCarrier.vue?vue&type=script&lang=js&"
export * from "./CompleteCarrier.vue?vue&type=script&lang=js&"
import style0 from "./CompleteCarrier.vue?vue&type=style&index=0&id=54acba5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54acba5e",
  null
  
)

export default component.exports